import { object as YupObject, string as YupString } from 'yup';

export const APPLICATION_QUESTION_TYPE_FREE_TEXT = 'free_text';

export interface ApplicationQuestionsFormValues {
  applicationQuestions: ApplicationQuestionType[];
}

export interface ApplicationQuestionType {
  activityApplicationQuestionId?: string;
  order: number;
  label: string;
  type: string;
  required: boolean;
}

export const validationSchema = YupObject().shape({
  label: YupString()
    .trim()
    .required('Please provide a question'),
});
